module.exports = __webpack_public_path__ + "99106fbb05ec078f52d10e7d6fdda122.jpg";